import { IMiniMachineState } from 'src/machines/shared';
import { useSelector } from '@xstate/react';
import usePolarisActor from 'src/hooks/usePolarisActor';

function useIsEditing() {
  const actor = usePolarisActor();

  return useSelector(actor as any, (state: IMiniMachineState) =>
    state.matches({ answering: { protocolMode: 'editingAnswers' } }),
  );
}

export default useIsEditing;
